import { Navigate, useParams } from 'react-router';

/**
 * Redirects a legacy path to its new location, keeping what the `*` route segment matched.
 */
export const RedirectWithSuffix = ({ to }: { to: string }) => {
  const { '*': suffix } = useParams();

  return <Navigate to={suffix ? `${to}/${suffix}` : to} replace />;
};
